import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { when } from 'lit/directives/when.js';
import { blueCorner } from '../svg';

@customElement('umb-market-banner')
export class UmbMarketBanner extends LitElement {
  @property()
  featureText?: string;

  @property()
  text!: string;

  @property()
  icon?: string;

  @property()
  align = 'center';

  constructor() {
    super();

    this.style.backgroundImage = `url("data:image/svg+xml;utf8,${encodeURIComponent(blueCorner)}")`;
  }

  render() {
    return html`
      <div id="inner">
        ${when(this.icon, () => html`<div id="icon">${this.icon}</div>`)}
        ${unsafeHTML(this.text)}
        ${when(
          this.featureText,
          () => html` <div id="feature">${unsafeHTML(this.featureText)}</div>`
        )}
      </div>
    `;
  }

  static styles = [
    css`
      :host {
        display: block;
        background-color: var(--uui-color-current);
        border-radius: 0 var(--m-spacer) var(--m-spacer) 0;
        background-repeat: no-repeat;
        background-position: bottom right;
        background-attachment: scroll;
        background-size: contain;
        width: 100%;
        position: relative;
        margin-bottom: var(--xl-spacer);
      }

      @media (max-width: 767px) {
        :host {
          background-image: none !important;
        }
      }

      :host([align='left']) #inner {
        display: flex;
        flex-direction: column;
        justify-content: center;
      }

      :host([align='left']) #inner p {
        margin: 0;
      }

      :host::after {
        content: '';
        position: absolute;
        z-index: -1;
        top: 0;
        bottom: 0;
        width: 100vw;
        left: -50vw;
        background: var(--color-banner-surface, var(--uui-color-current));
      }

      #inner {
        box-sizing: border-box;
        padding: var(--l-spacer) var(--m-spacer) var(--l-spacer) 0;
      }

      #feature {
        align-items: center;
        display: flex;
        position: relative;
        max-width: 800px;
        margin-top: var(--l-spacer);
        padding: var(--m-spacer);
        background: var(--uui-color-current-contrast);
        border-radius: var(--s-spacer);
        color: var(--uui-color-surface);
      }

      h2 {
        color: var(--uui-color-default);
        font-size: var(--h2-font-size);
        -webkit-font-smoothing: antialiased;
        line-height: 49px;
        font-weight: 400;
        margin: 0 0 var(--s-spacer);
      }

      p {
        font-size: 18px;
        line-height: 26px;
        font-weight: 400;
        max-width: 800px;
      }

      p:last-child {
        margin-bottom: 0;
      }

      a {
        color: var(--uui-color-surface);
      }

      #icon {
        display: none;
      }

      #feature svg {
        width: 5rem;
        height: 5rem;
        position: absolute;
        top: -2rem;
        right: -2.2rem;
        pointer-events: none;
      }

      #feature p {
        margin: 0;
      }

      @media (min-width: 767px) {
        #icon {
          display: flex;
          align-items: center;
          justify-content: center;
          background: var(--uui-color-default);
          box-sizing: border-box;
          border-radius: 50%;
          margin-bottom: var(--s-spacer);
          width: 60px;
          height: 60px;
        }

        #icon svg {
          stroke-width: 1.5;
          width: 28px;
          height: 28px;
          stroke: var(--uui-color-surface);
          display: block;
        }

        #inner {
          padding: var(--xl-spacer) 0;
          display: block;
          margin: 0;
          min-height: 285px;
          padding-right: 300px;
        }
      }
    `,
  ];
}
